// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.attribtable-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

div.attribtable-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 2.75em;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200, 0.9);
    z-index: 2;
}

div.attribtable-overlay > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}

div.dock-window > div.resizeable-window-body > div.attribtable-body {
    /* titlebar: 2.5em, padding: 0.5em */
    max-height: calc(100vh - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/
}

div.attribtable-toolbar {
    display: flex;
    align-items: center;
    padding: 0.25em;
    flex: 0 0 auto;
}

div.attribtable-toolbar > * {
    margin: 0.125em;
}

div.attribtable-toolbar > select {
    border: 1px solid var(--border-color);
    height: 2em;
}

div.attribtable-contents {
    flex: 1 1 auto;
    background-color: var(--list-bg-color);
    overflow: auto;
    border: 1px solid var(--border-color);
}

table.attribtable-table {
    min-width: 100%;
}

table.attribtable-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 0;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    box-shadow: inset -1px 0 0 var(--border-color),
                inset 0 -1px 0 var(--border-color);
}

table.attribtable-table th:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
}

table.attribtable-table th > span {
    margin: 0 0 -1px -1px;
    padding: 0.25em;
    display: flex;
    align-items: center;
    position: relative;
}

span.attribtable-table-headername {
    flex: 1 1 auto;
    text-align: left;
}

table.attribtable-table th > span > span.icon {
    flex: 0 0 auto;
    margin-left: 0.5em;
}

table.attribtable-table tr:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

table.attribtable-table tr:hover:not(.row-disabled) {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

table.attribtable-table td:first-child {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    align-items: center;
    padding: 0.25em 0.5em;
    background-clip: padding-box;
    position: sticky;
    left: 0;
    z-index: 1;
    width: 2.5em;
}

table.attribtable-table td:first-child::after {
    position: absolute;
    right: -1px;
    top: 0;
    bottom: 0;
    border-right: 1px solid var(--border-color);
    content: '';
}

span.attribtable-table-ldraghandle,
span.attribtable-table-rdraghandle {
    display: block;
    position: absolute;
    width: 4px;
    top: 0;
    bottom: 0;
    cursor: ew-resize;
}

span.attribtable-table-ldraghandle {
    left: -1px;
}

span.attribtable-table-rdraghandle {
    right: 0px;
}

span.attribtable-table-tdraghandle,
span.attribtable-table-bdraghandle {
    display: block;
    position: absolute;
    height: 4px;
    left: 0;
    right: 0;
    cursor: ns-resize;
}

span.attribtable-table-tdraghandle {
    top: -1px;
}

span.attribtable-table-bdraghandle {
    bottom: 0px;
}

table.attribtable-table {
    table-layout: fixed;
}

table.attribtable-table td {
    border: 1px solid var(--border-color);
    text-align: center;
    vertical-align: center;
    position: relative;
}

table.attribtable-table td > input:not([type=checkbox]),
table.attribtable-table td > select,
table.attribtable-table td pre.text-input,
table.attribtable-table td > span.edit-upload-field {
    width: 100%;
    min-width: 4em;
    border: none!important;
    background-color: transparent!important;
    margin: 0;
}

table.attribtable-table td > div.TextInput,
table.attribtable-table td > div.TextInput > pre {
    min-height: 2em;
}

table.attribtable-table td > *:disabled,
table.attribtable-table tr.row-disabled,
table.attribtable-table tr.row-disabled * {
    color: var(--text-color-disabled);
    cursor: not-allowed!important;
}

div.attribtable-footbar {
    flex: 0 0 auto;
    display: flex;
}

div.attribtable-footbar > div {
    margin: 0.25em;
}

div.attribtable-footbar > div.navbar {
    flex: 0 0 auto;
}

div.attribtable-filter {
    display: inline-flex;
    align-items: center;
    flex: 1 1 auto;
}

div.attribtable-filter input {
    flex: 1 1 auto;
    width: 0;
}

body.ewresizing, body.ewresizing * {
    cursor: ew-resize!important;
}

body.nsresizing, body.nsresizing * {
    cursor: ns-resize!important;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/AttributeTable.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,wFAAwF,EAAE,6DAA6D;IACvJ,uGAAuG,EAAE,6DAA6D;AAC1K;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,sCAAsC;IACtC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,UAAU;IACV,wCAAwC;IACxC,+BAA+B;IAC/B;kDAC8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,2CAA2C;IAC3C,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;;;IAII,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,uCAAuC;IACvC,SAAS;AACb;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["div.attribtable-body {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n}\n\ndiv.attribtable-overlay {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 2.75em;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200, 0.9);\n    z-index: 2;\n}\n\ndiv.attribtable-overlay > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n\ndiv.dock-window > div.resizeable-window-body > div.attribtable-body {\n    /* titlebar: 2.5em, padding: 0.5em */\n    max-height: calc(100vh - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - 0.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - titlebar - window_padding - topbar - bottombar*/\n}\n\ndiv.attribtable-toolbar {\n    display: flex;\n    align-items: center;\n    padding: 0.25em;\n    flex: 0 0 auto;\n}\n\ndiv.attribtable-toolbar > * {\n    margin: 0.125em;\n}\n\ndiv.attribtable-toolbar > select {\n    border: 1px solid var(--border-color);\n    height: 2em;\n}\n\ndiv.attribtable-contents {\n    flex: 1 1 auto;\n    background-color: var(--list-bg-color);\n    overflow: auto;\n    border: 1px solid var(--border-color);\n}\n\ntable.attribtable-table {\n    min-width: 100%;\n}\n\ntable.attribtable-table th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    padding: 0;\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    box-shadow: inset -1px 0 0 var(--border-color),\n                inset 0 -1px 0 var(--border-color);\n}\n\ntable.attribtable-table th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 2;\n}\n\ntable.attribtable-table th > span {\n    margin: 0 0 -1px -1px;\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\nspan.attribtable-table-headername {\n    flex: 1 1 auto;\n    text-align: left;\n}\n\ntable.attribtable-table th > span > span.icon {\n    flex: 0 0 auto;\n    margin-left: 0.5em;\n}\n\ntable.attribtable-table tr:nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ntable.attribtable-table tr:hover:not(.row-disabled) {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ntable.attribtable-table td:first-child {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    align-items: center;\n    padding: 0.25em 0.5em;\n    background-clip: padding-box;\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    width: 2.5em;\n}\n\ntable.attribtable-table td:first-child::after {\n    position: absolute;\n    right: -1px;\n    top: 0;\n    bottom: 0;\n    border-right: 1px solid var(--border-color);\n    content: '';\n}\n\nspan.attribtable-table-ldraghandle,\nspan.attribtable-table-rdraghandle {\n    display: block;\n    position: absolute;\n    width: 4px;\n    top: 0;\n    bottom: 0;\n    cursor: ew-resize;\n}\n\nspan.attribtable-table-ldraghandle {\n    left: -1px;\n}\n\nspan.attribtable-table-rdraghandle {\n    right: 0px;\n}\n\nspan.attribtable-table-tdraghandle,\nspan.attribtable-table-bdraghandle {\n    display: block;\n    position: absolute;\n    height: 4px;\n    left: 0;\n    right: 0;\n    cursor: ns-resize;\n}\n\nspan.attribtable-table-tdraghandle {\n    top: -1px;\n}\n\nspan.attribtable-table-bdraghandle {\n    bottom: 0px;\n}\n\ntable.attribtable-table {\n    table-layout: fixed;\n}\n\ntable.attribtable-table td {\n    border: 1px solid var(--border-color);\n    text-align: center;\n    vertical-align: center;\n    position: relative;\n}\n\ntable.attribtable-table td > input:not([type=checkbox]),\ntable.attribtable-table td > select,\ntable.attribtable-table td pre.text-input,\ntable.attribtable-table td > span.edit-upload-field {\n    width: 100%;\n    min-width: 4em;\n    border: none!important;\n    background-color: transparent!important;\n    margin: 0;\n}\n\ntable.attribtable-table td > div.TextInput,\ntable.attribtable-table td > div.TextInput > pre {\n    min-height: 2em;\n}\n\ntable.attribtable-table td > *:disabled,\ntable.attribtable-table tr.row-disabled,\ntable.attribtable-table tr.row-disabled * {\n    color: var(--text-color-disabled);\n    cursor: not-allowed!important;\n}\n\ndiv.attribtable-footbar {\n    flex: 0 0 auto;\n    display: flex;\n}\n\ndiv.attribtable-footbar > div {\n    margin: 0.25em;\n}\n\ndiv.attribtable-footbar > div.navbar {\n    flex: 0 0 auto;\n}\n\ndiv.attribtable-filter {\n    display: inline-flex;\n    align-items: center;\n    flex: 1 1 auto;\n}\n\ndiv.attribtable-filter input {\n    flex: 1 1 auto;\n    width: 0;\n}\n\nbody.ewresizing, body.ewresizing * {\n    cursor: ew-resize!important;\n}\n\nbody.nsresizing, body.nsresizing * {\n    cursor: ns-resize!important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
